import { ReactElement } from "react";
import clsx from "clsx";

export const TopbarContainer = ({
  children,
  className,
}: {
  children: ReactElement | ReactElement[];
  className?: string;
}) => {
  return (
    <div className={clsx("border-b border-slate-200 px-6 py-[20px]", className)}>
      {children}
    </div>
  );
};
